<template>
    <v-footer
      padless 
      height="auto"
    >
      <v-layout
        justify-center 
        row 
        wrap
      >
        <v-flex 
          py-3 
          text-center 
          white--text 
          xs12
        >
          &copy;{{ new Date().getFullYear() }} — <strong>Liberum.club</strong>
          Made with 
            <v-icon size="small">favorite</v-icon>
            by <a href="https://liberum.club" target="_blank">sveratum</a>
        </v-flex>
      </v-layout>
    </v-footer>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>

</style>